import React from "react";

const EmptyPage = () => <></>;

export default EmptyPage;
